import type { GridRowId } from '@mui/x-data-grid-pro';

import type { Importable } from '../../ImportTable/types/importable';

type FieldWithOrgAndUnit = {
  unitId?: string;
};

const importUniqueRoomValidator =
  (errorMessage: string) =>
  <TFieldTypes extends FieldWithOrgAndUnit>(
    uniqueId: GridRowId,
    params: TFieldTypes,
    field: keyof TFieldTypes,
    rows: Importable<TFieldTypes>[],
  ) => {
    const value = params[field];

    if (!value) {
      return null;
    }

    const { unitId } = params;

    if (
      rows.some(
        (row) =>
          row.$meta.uniqueId !== uniqueId &&
          row.unitId === unitId &&
          row[field] === value,
      )
    ) {
      return errorMessage;
    }

    return null;
  };

export default importUniqueRoomValidator;
